module.exports = __webpack_public_path__ + "img/pethouse01.b982edc4.jpg";